import { Form, Formik } from 'formik';
import { Props, Values } from './DocumentOptionalFields.types';
import * as Yup from 'yup';
import FormField from '../../components/field/FormField';
import Button from '../../components/button/Button';
import { useTranslation } from '../../context/translationContext';
import { OptionalFieldType } from '../../types/Invoice';
import { ObjectFromEnum, convertEnumToArray } from '../../utils/functions/data.functions';
import { useCurrentCompany } from '../../hooks/useCompany';
import { Lang } from '../../types/core/language';

export const DocumentOptionalFieldsForm = ({ onSubmit, initialValues, onBack }: Props) => {
  const { company } = useCurrentCompany();
  const { t } = useTranslation();
  const _initialValues: Values = {
    id: initialValues?.id ?? undefined,
    isActive: initialValues?.isActive ?? true,
    isDefault: initialValues?.isDefault ?? false,
    value: initialValues?.value ?? '',
    fieldType: initialValues?.fieldType ?? OptionalFieldType.Header,
    companyId: company?.id,
    language: initialValues?.language ?? 'en',
  };

  const CompanySchema = Yup.object().shape({
    fieldType: Yup.string().required('Field type is required.'),
    value: Yup.string().required('Value is required.'),
  });

  return (
    <Formik
      enableReinitialize
      initialValues={_initialValues}
      onSubmit={onSubmit}
      validationSchema={CompanySchema}
    >
      {({ errors, touched, values, setFieldValue }) => (
        <Form className="w-full text-center">
          <div className="my-4">
            <FormField
              id="value"
              name="value"
              label={t('page.optional-field.col-value')}
              errors={errors}
              touched={touched}
            />
          </div>
          <div className="my-4">
            <FormField
              type="select"
              id="fieldType"
              name="fieldType"
              onChange={(e) => {
                if (!e.target.value) return;
                setFieldValue('fieldType', e.target.value);
              }}
            >
              {convertEnumToArray(OptionalFieldType).map((opt: ObjectFromEnum, index: number) => (
                <option key={index} value={opt.value}>
                  {opt.name}
                </option>
              ))}
            </FormField>
          </div>
          <div className="my-4">
            <FormField
              type="select"
              id="language"
              name="language"
              onChange={(e) => {
                if (!e.target.value) return;
                setFieldValue('language', e.target.value);
              }}
            >
              {convertEnumToArray(Lang).map((opt: ObjectFromEnum, index: number) => (
                <option key={index} value={opt.value}>
                  {opt.name}
                </option>
              ))}
            </FormField>
          </div>
          <div className="my-4 flex flex-row items-center">
            <label htmlFor={'isActive'} className="mr-5">
              {t('page.optional-field.input-is-active')}
            </label>
            <FormField
              name={'isActive'}
              id={'isActive'}
              type="checkbox"
              checked={values?.isActive}
              className={`w-4 h-4`}
            />
          </div>
          <div className="my-4 flex flex-row items-center">
            <label htmlFor={'isDefault'} className="mr-5">
              {t('page.optional-field.input-is-default')}
            </label>
            <FormField
              name={'isDefault'}
              id={'isDefault'}
              type="checkbox"
              checked={values?.isDefault}
              className={`w-4 h-4`}
            />
          </div>

          <div className="flex float-left">
            <Button title={t('general.back')} color="gray" className="mr-3" onClick={onBack} />
            <Button title={t('general.save')} color="green" type="submit" showLoading />
          </div>
        </Form>
      )}
    </Formik>
  );
};
